import { render, staticRenderFns } from "./OpentableSettings.vue?vue&type=template&id=188d7f14"
import script from "./OpentableSettings.vue?vue&type=script&lang=js"
export * from "./OpentableSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports